import { Form, InputGroup } from "react-bootstrap"
import { BsSearch, BsX } from "react-icons/bs"
import { useState, KeyboardEvent } from "react"

interface SearchbarProps {
    classes?: string;
    onSearch?: (searchTerm: string) => void;
}

export default function Searchbar({ classes, onSearch }: SearchbarProps) {
    const [searchTerm, setSearchTerm] = useState("");
    
    const styling = " silver-border border-radius-4"
    if (!classes) {
        classes = styling;
    } else {
        classes += styling;
    }

    const handleSearch = () => {
        if (onSearch) {
            onSearch(searchTerm);
        }
    };

    const handleClear = () => {
        setSearchTerm("");
        if (onSearch) {
            onSearch("");
        }
    };

    const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <InputGroup className={classes}>
            <Form.Control 
                type="text" 
                placeholder="Search" 
                aria-label="Search" 
                className="color-silver transparent-background search-text no-border" 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyPress={handleKeyPress}
            />
            {searchTerm && (
                <InputGroup.Text 
                    className="transparent-background color-silver no-border"
                    onClick={handleClear}
                    style={{ cursor: 'pointer' }}
                >
                    <BsX />
                </InputGroup.Text>
            )}
            <InputGroup.Text 
                className="transparent-background color-silver no-border"
                onClick={handleSearch}
                style={{ cursor: 'pointer' }}
            >
                <BsSearch />
            </InputGroup.Text>
        </InputGroup>
    )
}
